import StarsRating from "./StarsRating";
import { getDeviationText, getRatingText } from "../../app/fitness";

const FitnessRatingElement = ({rating, deviation}) => {
    function getRatingElement(rating) {
        const { text, style } = getRatingText(rating);
        return (
            <div className={style + " ms-1"}>
                {text}
            </div>
        )
    }

    function getDeviationElement(deviation, rating) {
        let { text, style } = getDeviationText(deviation);

        if (rating !== undefined) {
            // Override style by rating style
            const { style: ratingStyle } = getRatingText(rating);
            style = ratingStyle;
        }

        return (
            <div className={style + " ms-1"}>
                {text}
            </div>
        );
    }

    return (
        <div className="d-lg-flex">
            <StarsRating rating={rating} /> {deviation ? getDeviationElement(deviation, rating) : getRatingElement(rating)}
        </div>
    );
};

export default FitnessRatingElement;
